import {
  setPriceIncluded,
  findParentOfSecondaryAccessory,
  findSecondaryAccessoryId,
} from '@tcp/core/src/services/abstractors/SFCC/AddedToBag';

import { getCartItemInfo } from '@tcp/core/src/components/features/CnC/AddedToBag/util/utility';

export const getModifiedItem = (item) => {
  const customizationData = {
    color: item?.styleWithData?.product?.colorFitsSizesMap[0]?.color?.name,
    fit: item?.styleWithData?.product?.colorFitsSizesMap[0]?.fits[0]?.fitName,
    quantity: 1,
    size: item?.styleWithData?.product?.colorFitsSizesMap[0]?.fits[0]?.sizes[0]?.sizeName,
    styleType: item?.productInfo?.tcpStyleType,
  };
  const modifiedProduct = item?.styleWithData?.product;
  modifiedProduct.varientCount = item?.productInfo?.varientCount;
  return getCartItemInfo(modifiedProduct, customizationData);
};

export const getModifiedSelectedItem = (item, id = 0) => {
  const customizationData = {
    color: item?.styleWithData?.product?.colorFitsSizesMap[0]?.color?.name,
    fit: item?.styleWithData?.product?.colorFitsSizesMap[0]?.fits[0]?.fitName,
    quantity: 1,
    size: item?.styleWithData?.product?.colorFitsSizesMap[0]?.fits[0]?.sizes[id]?.sizeName,
    styleType: item?.productInfo?.tcpStyleType,
  };
  const modifiedProduct = item?.styleWithData?.product;
  modifiedProduct.varientCount = item?.productInfo?.varientCount;
  return getCartItemInfo(modifiedProduct, customizationData);
};

export const checkProduct = (selectedAccessories) => {
  return selectedAccessories.map((accessory) => accessory?.skuInfo?.productId);
};

export const toPriceShow = (item, selectedAccessories, customizationType) => {
  if (customizationType === 'optional') return null;
  if (
    selectedAccessories?.length > 0 &&
    item &&
    item?.skuInfo?.productId === selectedAccessories[0]?.skuInfo?.productId
  ) {
    return 'price-no-show';
  }
  return null;
};

export const isPriceVisible = (selectedAccessories, customizationType) => {
  return selectedAccessories?.length > 0 || customizationType === 'optional'
    ? null
    : 'price-hidden';
};

export const checkForOOS = (allOrderItems = [], accessoriesOfParent) => {
  let parentAcc = accessoriesOfParent && [...accessoriesOfParent];
  let flag = false;
  const unavailableAcc = [];

  if (parentAcc && parentAcc.length && allOrderItems && allOrderItems.length) {
    parentAcc.forEach((primaryId) => {
      allOrderItems.forEach((item) => {
        if (item?.productInfo?.generalProductId === primaryId && item?.miscInfo?.c_accessories) {
          parentAcc = [...parentAcc, ...item.miscInfo.c_accessories];
        }
      });
    });
  }

  if (!Array.isArray(parentAcc)) {
    return {
      flag,
      unavailableAcc,
    };
  }

  while (parentAcc.length > 0) {
    const accId = parentAcc.pop();
    // eslint-disable-next-line no-loop-func
    allOrderItems.forEach((item) => {
      if (
        item.productInfo.generalProductId === accId &&
        item.miscInfo.availability === 'UNAVAILABLE'
      ) {
        flag = true;
        unavailableAcc.push(accId);
      }
    });
  }
  return {
    flag,
    unavailableAcc,
  };
};

export const checkIf0007Present = (parentProductId, orderAccessorieItems) => {
  let accessoryList = [];

  const items = [];
  Object.entries(orderAccessorieItems).map(([key, value]) => {
    if (key === parentProductId && value?.miscInfo?.c_accessories) {
      accessoryList = [...value.miscInfo.c_accessories];
    }
    return null;
  });

  if (accessoryList && accessoryList.length > 0) {
    accessoryList.forEach((element) => {
      if (orderAccessorieItems[element]) {
        items.push(orderAccessorieItems[element]);
      }
    });
    const list0007 = items.filter((item) => item.productInfo.tcpStyleType === '0007');
    if (list0007 && list0007?.length > 0) return true;
    return false;
  }
  return false;
};

export const getIsSecondaryAccessorySelected = (selectedAccessories, uniqueId, parentProductId) => {
  for (let i = 0; i < selectedAccessories.length; i += 1) {
    if (
      selectedAccessories[i]?.skuInfo.productId === uniqueId &&
      parentProductId === selectedAccessories[i].parentProductId
    ) {
      return true;
    }
  }
  return false;
};

export const markPriceIncluded = (
  accessories = [],
  secondaryAccessories = [],
  isMandatoryCustomization
) => {
  let acc0007present = false;
  const acc007arr = [];
  accessories.forEach((item) => {
    if (item.skuInfo.TCPStyleType === '0007') {
      acc0007present = true;
      acc007arr.push(item?.skuInfo?.variantId);
    }
  });
  const primaryArray =
    accessories &&
    accessories.map((item, index) => {
      const isIncluded = isMandatoryCustomization
        ? setPriceIncluded(item, index, accessories, acc0007present, acc007arr)
        : false;

      return {
        ...item,
        c_priceIncluded: isIncluded,
      };
    });

  const secondaryArray =
    secondaryAccessories &&
    secondaryAccessories.map((item) => {
      const { skuInfo = {} } = item || {};
      const { variantId = '' } = skuInfo || {};
      const primaryAccessory = findParentOfSecondaryAccessory(item.parentProductId, accessories);
      const secondaryAccessoryItem = findSecondaryAccessoryId(
        primaryAccessory,
        secondaryAccessories
      );
      const isIncluded = secondaryAccessoryItem.indexOf(variantId) === 0;
      return {
        ...item,
        c_priceIncluded: isIncluded,
      };
    });

  return [...primaryArray, ...secondaryArray];
  // return final;
};

export default {
  getModifiedItem,
  checkProduct,
  toPriceShow,
  isPriceVisible,
  checkForOOS,
  getIsSecondaryAccessorySelected,
  markPriceIncluded,
};
